import {Theme, createStyles} from '@material-ui/core';

export const broadtechHorizonStyles = (theme: Theme) =>
	createStyles({
		section: {
			paddingTop: theme.spacing(12),
			paddingBottom: theme.spacing(12),
			overflow: 'hidden',
		},
		title: {
			[theme.breakpoints.down('sm')]: {
				lineHeight: theme.typography.pxToRem(24),
				fontSize: theme.typography.pxToRem(20),
			},
			[theme.breakpoints.down('xs')]: {
				lineHeight: theme.typography.pxToRem(24),
				fontSize: theme.typography.pxToRem(15),
				marginTop: theme.spacing(1),
			},
		},
		subtitle: {
			position: 'absolute',
			whiteSpace: 'pre-wrap',
			lineHeight: theme.typography.pxToRem(26),
			fontSize: theme.typography.pxToRem(22),
			[theme.breakpoints.down('xs')]: {
				fontSize: theme.typography.pxToRem(12),
				lineHeight: theme.typography.pxToRem(16),
			},
		},
		imageBox: {
			position: 'relative',
			display: 'inline-block',
		},
		imageBoxWeb: {
			[theme.breakpoints.down('xs')]: {
				width: '100%',
				marginLeft: theme.spacing(-4),
			},
		},
		imageBoxDesktop: {
			position: 'absolute',
			top: '50%',
			left: 'calc(50% + 60px)',
			transform: 'translateY(-50%)',
			zIndex: 2,
			[theme.breakpoints.down('sm')]: {
				width: 'fit-content',
			},
			[theme.breakpoints.down('xs')]: {
				right: theme.spacing(4),
				top: 0,
				width: '115%',
			},
		},
		imageBoxMobile: {
			zIndex: 3,
		},
		subtitleWeb: {
			bottom: '50%',
			left: theme.typography.pxToRem(26),
			color: '#A14D6E',
			[theme.breakpoints.down('xs')]: {
				bottom: 'auto',
				top: theme.typography.pxToRem(40),
				marginLeft: theme.spacing(-4),
				left: '50%',
			},
		},
		subtitleMobile: {
			top: theme.typography.pxToRem(60),
			textAlign: 'center',
			width: '100%',
			color: '#98958B',
			[theme.breakpoints.down('xs')]: {
				top: theme.typography.pxToRem(30),
			},
		},
		subtitleDesktop: {
			top: theme.typography.pxToRem(26),
			right: theme.typography.pxToRem(26),
			color: theme.palette.common.white,
			[theme.breakpoints.down('xs')]: {
				top: theme.typography.pxToRem(13),
				right: theme.typography.pxToRem(13),
			},
		},
		image: {
			[theme.breakpoints.down('sm')]: {
				width: '100%',
			},
		},
		grid: {
			justifyContent: 'center',
			display: 'flex',
			position: 'relative',
		},
		secondRow: {
			marginTop: theme.typography.pxToRem(-80),
		},
	});
